module.exports = __webpack_public_path__ + "static/media/truck-loading.bcc092b2.svg";